import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuth: false,
    tokenpub: localStorage.getItem('tokenpub') || '',
    tokenscr: localStorage.getItem('tokenscr') || '',
    usernik: localStorage.getItem('usernik') || '',
    userrole: localStorage.getItem('userrole') || '',
    username: localStorage.getItem('username') || '',
    userbanjar: localStorage.getItem('userbanjar') || '',
    userbanjarname: localStorage.getItem('userbanjarname') || '',
    staticdata: localStorage.getItem('staticdata') || null,
  },
  mutations: {
    SET_STATICDATA(state, resp) {
      // set localStorage
      localStorage.setItem('staticdata', resp);
      // set state
      state.staticdata = resp;
    },
    AUTH_SUCCESS(state, resp) {
      // set localStorage
      localStorage.setItem('tokenscr', resp.token);
      localStorage.setItem('usernik', resp.nik);
      localStorage.setItem('userrole', resp.role);
      localStorage.setItem('username', resp.nama);
      localStorage.setItem('userbanjar', resp.id_banjar);
      localStorage.setItem('userbanjarname', resp.banjar);
      // set state
      state.tokenscr = resp.token;
      state.usernik = resp.nik;
      state.userrole = resp.role;
      state.username = resp.nama;
      state.userbanjar = resp.id_banjar;
      state.userbanjarname = resp.banjar;
      state.isAuth = true;
    },
    AUTH_LOGOUT(state) {
      // set localStorage
      localStorage.removeItem('tokenscr');
      localStorage.removeItem('usernik');
      localStorage.removeItem('userrole');
      localStorage.removeItem('username');
      localStorage.removeItem('userbanjar');
      localStorage.removeItem('userbanjarname');
      // set state
      state.tokenscr = '';
      state.usernik = '';
      state.userrole = '';
      state.username = '';
      state.userbanjar = '';
      state.userbanjarname = '';
      state.isAuth = false;
    },
  },
  actions: {
  },
  getters: {
    isAuth: (state) => state.isAuth,
    tokenpub: (state) => state.tokenpub,
    tokenscr: (state) => state.tokenscr,
    usernik: (state) => state.usernik,
    userrole: (state) => state.userrole,
    username: (state) => state.username,
    userbanjar: (state) => state.userbanjar,
    userbanjarname: (state) => state.userbanjarname,
    staticdata: (state) => state.staticdata,
  },
});
